// call-it-out/src/analytics.js
import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";

const GAME_NAME = "call_it_out";

export const trackGameCreated = (gameId) => {
  if (!analytics) return;
  logEvent(analytics, "game_created", {
    game: GAME_NAME,
    game_id: gameId,
  });
};

export const trackPlayerJoined = (gameId) => {
  if (!analytics) return;
  logEvent(analytics, "player_joined", {
    game: GAME_NAME,
    game_id: gameId,
  });
};

export const trackPlayerDisconnected = (gameId) => {
  if (!analytics) return;
  logEvent(analytics, "player_disconnected", {
    game: GAME_NAME,
    game_id: gameId,
  });
};

export const trackGameJoinFailed = (reason) => {
  if (!analytics) return;
  logEvent(analytics, "game_join_failed", {
    game: GAME_NAME,
    reason,
  });
};

export const trackTurnEnded = (gameId) => {
  if (!analytics) return;
  logEvent(analytics, "turn_ended", {
    game: GAME_NAME,
    game_id: gameId,
  });
};

export const trackPromptChosen = (deck, cardId) => {
  if (!analytics) return;
  logEvent(analytics, "prompt_chosen", {
    game: GAME_NAME,
    deck,
    card_id: cardId,
  });
};

export const trackGameEnded = (gameId, turnCount, playerCount) => {
  if (!analytics) return;
  logEvent(analytics, "game_ended", {
    game: GAME_NAME,
    game_id: gameId,
    turn_count: turnCount,
    player_count: playerCount,
  });
};